import { SET_WAITER_CALLS_NOTIFICATIONS, SET_WAITER_CALLS_WAITERS } from '../../actionTypes/waiterCalls'

const initialState = {
	waiters: [],
	waiterNotifications: [],
}

export function waiterCallsReducer (state = initialState, action) {
	switch (action.type) {
		case SET_WAITER_CALLS_WAITERS:
			return {
				...state,
				waiters: action.value,
			}
		case SET_WAITER_CALLS_NOTIFICATIONS:
			return {
				...state,
				waiterNotifications: action.value,
			}
		default:
			return state
	}
}
